import React from 'react';
import getOutputHeaders from '../lib/getOutputHeaders';
import OutputViewerSection from '../OutputViewerSection';
import Page from '@/components/page/Page.jsx';

const HeaderSection = ({ response }) => {
  const headers = getOutputHeaders(response);

  const headerSections = Object.entries(headers).map(([key, values]) => {
    const items = Object.entries(values).map(([key, value]) => {
      return { key, value };
    });
    return <OutputViewerSection.Grid key={key} title={key} items={items} collapsable={true} />;
  });

  return <Page.Section variant="chromeless">{headerSections}</Page.Section>;
};

export default HeaderSection;
